// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v4.25.3
// source: messenger/arm_control_bot_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FileDescriptorProto as FileDescriptorProto1 } from "ts-proto-descriptors";
import { Empty, protoMetadata as protoMetadata4 } from "../google/protobuf/empty";
import { Pose, protoMetadata as protoMetadata1, Wrench } from "./geometry";
import { CanCommand, ModbusCommand, protoMetadata as protoMetadata2 } from "./grippers";
import { CollisionStatus, JointState, JointTrajectory, protoMetadata as protoMetadata3 } from "./joints";

export const protobufPackage = "armcontrolbot";

/** Joint connection status enum */
export enum JointConnectionStatus {
  JOINT_DISCONNECTED = 0,
  JOINT_CONNECTED = 1,
  JOINT_READY = 2,
  UNRECOGNIZED = -1,
}

export function jointConnectionStatusFromJSON(object: any): JointConnectionStatus {
  switch (object) {
    case 0:
    case "JOINT_DISCONNECTED":
      return JointConnectionStatus.JOINT_DISCONNECTED;
    case 1:
    case "JOINT_CONNECTED":
      return JointConnectionStatus.JOINT_CONNECTED;
    case 2:
    case "JOINT_READY":
      return JointConnectionStatus.JOINT_READY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JointConnectionStatus.UNRECOGNIZED;
  }
}

export function jointConnectionStatusToJSON(object: JointConnectionStatus): string {
  switch (object) {
    case JointConnectionStatus.JOINT_DISCONNECTED:
      return "JOINT_DISCONNECTED";
    case JointConnectionStatus.JOINT_CONNECTED:
      return "JOINT_CONNECTED";
    case JointConnectionStatus.JOINT_READY:
      return "JOINT_READY";
    case JointConnectionStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Desire mode for hybrid assembly operation */
export enum DesireMode {
  /** DESIRE_MODE_ASSEMBLY - Default: robby-server sends assembly desires */
  DESIRE_MODE_ASSEMBLY = 0,
  /** DESIRE_MODE_LIVE - ACB sends CombinedDesires */
  DESIRE_MODE_LIVE = 1,
  /** DESIRE_MODE_IDLE - Nobody sends desires, arm braked */
  DESIRE_MODE_IDLE = 2,
  UNRECOGNIZED = -1,
}

export function desireModeFromJSON(object: any): DesireMode {
  switch (object) {
    case 0:
    case "DESIRE_MODE_ASSEMBLY":
      return DesireMode.DESIRE_MODE_ASSEMBLY;
    case 1:
    case "DESIRE_MODE_LIVE":
      return DesireMode.DESIRE_MODE_LIVE;
    case 2:
    case "DESIRE_MODE_IDLE":
      return DesireMode.DESIRE_MODE_IDLE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DesireMode.UNRECOGNIZED;
  }
}

export function desireModeToJSON(object: DesireMode): string {
  switch (object) {
    case DesireMode.DESIRE_MODE_ASSEMBLY:
      return "DESIRE_MODE_ASSEMBLY";
    case DesireMode.DESIRE_MODE_LIVE:
      return "DESIRE_MODE_LIVE";
    case DesireMode.DESIRE_MODE_IDLE:
      return "DESIRE_MODE_IDLE";
    case DesireMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Response message for URDF data */
export interface URDFResponse {
  urdfXml: string;
}

/** Summary of hardware configuration across all joints */
export interface ArmHardwareConfig {
  hardwareVariant: string;
  armSerialNumber?: string | undefined;
  armRevision?: string | undefined;
  jointSerials: number[];
  /**
   * True once every ML-capable joint reports calibrated, false if any
   * definitively reports otherwise. Unset when only silence separates us from
   * an answer, or the arm has no ML-capable joints.
   */
  mlWindupCalibrated?: boolean | undefined;
}

export interface ControlBoxHardwareConfig {
  voltage: string;
}

/** Information about a single joint */
export interface JointInfo {
  jointNumber?: number | undefined;
  connectionStatus: JointConnectionStatus;
  /** RO1, RO2, THOR, SPARK, etc. */
  firmwareVariant?: string | undefined;
  firmwareBuildId?: string | undefined;
  jointSerial?:
    | number
    | undefined;
  /** True if joint is marked as JointFakeConfig in arm-control-bot.json */
  isFake?:
    | boolean
    | undefined;
  /**
   * Installed checksums (queried from CAN by ACB). Absent when the
   * joint is disconnected or fake.
   */
  installedCm7Checksum?: number | undefined;
  installedCm4Checksum?:
    | number
    | undefined;
  /**
   * Target checksums (from firmware-bot-cpp --list --json, matched to
   * this joint's (firmwareType, variant)). Absent when firmware-bot-cpp
   * is unreachable or this joint's (firmwareType, variant) is not in
   * the target set.
   */
  targetCm7Checksum?: number | undefined;
  targetCm4Checksum?:
    | number
    | undefined;
  /**
   * ACB-computed comparison of installed vs target:
   *   - true  when installed == target (all CM7/CM4 fields match), OR
   *           when the joint is fake (nothing to flash, treated as up to date).
   *   - false when installed != target.
   *   - absent when ACB can't determine (installed or target missing for a
   *           real joint). UI should fall back to buildId comparison.
   */
  firmwareUpToDate?: boolean | undefined;
}

/** Result wrapper for GetHardwareConfig */
export interface GetHardwareConfigResult {
  config: ArmHardwareConfig | undefined;
  cbConfig: ControlBoxHardwareConfig | undefined;
  errors: Error[];
}

/**
 * Message for end-effector IMU reporting configuration. Used by kalibrate-bot
 * to enable the ~250 Hz instantaneous accelerometer stream during MPA
 * smoothness runs, then disable it when the run ends. Default is off so we
 * don't waste CAN bandwidth outside of MPA.
 */
export interface SetImuReportingConfig {
  reportInstantaneousData: boolean;
}

/** Result for GetFirmwareInfo - firmware state across all known boards */
export interface GetFirmwareInfoResult {
  joints: JointInfo[];
}

export interface SetDesireModeRequest {
  mode: DesireMode;
}

export interface SetDesireModeResult {
  success: boolean;
  currentMode: DesireMode;
}

export interface GetDesireModeResult {
  currentMode: DesireMode;
}

export interface ControlSource {
  value: string;
  peerId?:
    | string
    | undefined;
  /** TODO: remove optional when everyone sends in client_id */
  clientId?: string | undefined;
}

export interface Error {
  message: string;
}

export interface SetControlSourceResult {
  newSource?: ControlSource | undefined;
  error?: Error | undefined;
}

function createBaseURDFResponse(): URDFResponse {
  return { urdfXml: "" };
}

export const URDFResponse: MessageFns<URDFResponse> = {
  encode(message: URDFResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.urdfXml !== "") {
      writer.uint32(10).string(message.urdfXml);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): URDFResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseURDFResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.urdfXml = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): URDFResponse {
    return { urdfXml: isSet(object.urdfXml) ? globalThis.String(object.urdfXml) : "" };
  },

  toJSON(message: URDFResponse): unknown {
    const obj: any = {};
    if (message.urdfXml !== "") {
      obj.urdfXml = message.urdfXml;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<URDFResponse>, I>>(base?: I): URDFResponse {
    return URDFResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<URDFResponse>, I>>(object: I): URDFResponse {
    const message = createBaseURDFResponse();
    message.urdfXml = object.urdfXml ?? "";
    return message;
  },
};

function createBaseArmHardwareConfig(): ArmHardwareConfig {
  return {
    hardwareVariant: "",
    armSerialNumber: undefined,
    armRevision: undefined,
    jointSerials: [],
    mlWindupCalibrated: undefined,
  };
}

export const ArmHardwareConfig: MessageFns<ArmHardwareConfig> = {
  encode(message: ArmHardwareConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hardwareVariant !== "") {
      writer.uint32(10).string(message.hardwareVariant);
    }
    if (message.armSerialNumber !== undefined) {
      writer.uint32(18).string(message.armSerialNumber);
    }
    if (message.armRevision !== undefined) {
      writer.uint32(26).string(message.armRevision);
    }
    writer.uint32(34).fork();
    for (const v of message.jointSerials) {
      writer.uint32(v);
    }
    writer.join();
    if (message.mlWindupCalibrated !== undefined) {
      writer.uint32(40).bool(message.mlWindupCalibrated);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArmHardwareConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArmHardwareConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.hardwareVariant = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.armSerialNumber = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.armRevision = reader.string();
          continue;
        }
        case 4: {
          if (tag === 32) {
            message.jointSerials.push(reader.uint32());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.jointSerials.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.mlWindupCalibrated = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArmHardwareConfig {
    return {
      hardwareVariant: isSet(object.hardwareVariant) ? globalThis.String(object.hardwareVariant) : "",
      armSerialNumber: isSet(object.armSerialNumber) ? globalThis.String(object.armSerialNumber) : undefined,
      armRevision: isSet(object.armRevision) ? globalThis.String(object.armRevision) : undefined,
      jointSerials: globalThis.Array.isArray(object?.jointSerials)
        ? object.jointSerials.map((e: any) => globalThis.Number(e))
        : [],
      mlWindupCalibrated: isSet(object.mlWindupCalibrated) ? globalThis.Boolean(object.mlWindupCalibrated) : undefined,
    };
  },

  toJSON(message: ArmHardwareConfig): unknown {
    const obj: any = {};
    if (message.hardwareVariant !== "") {
      obj.hardwareVariant = message.hardwareVariant;
    }
    if (message.armSerialNumber !== undefined) {
      obj.armSerialNumber = message.armSerialNumber;
    }
    if (message.armRevision !== undefined) {
      obj.armRevision = message.armRevision;
    }
    if (message.jointSerials?.length) {
      obj.jointSerials = message.jointSerials.map((e) => Math.round(e));
    }
    if (message.mlWindupCalibrated !== undefined) {
      obj.mlWindupCalibrated = message.mlWindupCalibrated;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArmHardwareConfig>, I>>(base?: I): ArmHardwareConfig {
    return ArmHardwareConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArmHardwareConfig>, I>>(object: I): ArmHardwareConfig {
    const message = createBaseArmHardwareConfig();
    message.hardwareVariant = object.hardwareVariant ?? "";
    message.armSerialNumber = object.armSerialNumber ?? undefined;
    message.armRevision = object.armRevision ?? undefined;
    message.jointSerials = object.jointSerials?.map((e) => e) || [];
    message.mlWindupCalibrated = object.mlWindupCalibrated ?? undefined;
    return message;
  },
};

function createBaseControlBoxHardwareConfig(): ControlBoxHardwareConfig {
  return { voltage: "" };
}

export const ControlBoxHardwareConfig: MessageFns<ControlBoxHardwareConfig> = {
  encode(message: ControlBoxHardwareConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voltage !== "") {
      writer.uint32(10).string(message.voltage);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ControlBoxHardwareConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseControlBoxHardwareConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voltage = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ControlBoxHardwareConfig {
    return { voltage: isSet(object.voltage) ? globalThis.String(object.voltage) : "" };
  },

  toJSON(message: ControlBoxHardwareConfig): unknown {
    const obj: any = {};
    if (message.voltage !== "") {
      obj.voltage = message.voltage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ControlBoxHardwareConfig>, I>>(base?: I): ControlBoxHardwareConfig {
    return ControlBoxHardwareConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ControlBoxHardwareConfig>, I>>(object: I): ControlBoxHardwareConfig {
    const message = createBaseControlBoxHardwareConfig();
    message.voltage = object.voltage ?? "";
    return message;
  },
};

function createBaseJointInfo(): JointInfo {
  return {
    jointNumber: undefined,
    connectionStatus: 0,
    firmwareVariant: undefined,
    firmwareBuildId: undefined,
    jointSerial: undefined,
    isFake: undefined,
    installedCm7Checksum: undefined,
    installedCm4Checksum: undefined,
    targetCm7Checksum: undefined,
    targetCm4Checksum: undefined,
    firmwareUpToDate: undefined,
  };
}

export const JointInfo: MessageFns<JointInfo> = {
  encode(message: JointInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jointNumber !== undefined) {
      writer.uint32(8).int32(message.jointNumber);
    }
    if (message.connectionStatus !== 0) {
      writer.uint32(16).int32(message.connectionStatus);
    }
    if (message.firmwareVariant !== undefined) {
      writer.uint32(26).string(message.firmwareVariant);
    }
    if (message.firmwareBuildId !== undefined) {
      writer.uint32(34).string(message.firmwareBuildId);
    }
    if (message.jointSerial !== undefined) {
      writer.uint32(40).uint32(message.jointSerial);
    }
    if (message.isFake !== undefined) {
      writer.uint32(48).bool(message.isFake);
    }
    if (message.installedCm7Checksum !== undefined) {
      writer.uint32(56).int32(message.installedCm7Checksum);
    }
    if (message.installedCm4Checksum !== undefined) {
      writer.uint32(64).int32(message.installedCm4Checksum);
    }
    if (message.targetCm7Checksum !== undefined) {
      writer.uint32(72).int32(message.targetCm7Checksum);
    }
    if (message.targetCm4Checksum !== undefined) {
      writer.uint32(80).int32(message.targetCm4Checksum);
    }
    if (message.firmwareUpToDate !== undefined) {
      writer.uint32(88).bool(message.firmwareUpToDate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): JointInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJointInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.jointNumber = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.connectionStatus = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.firmwareVariant = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.firmwareBuildId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.jointSerial = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isFake = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.installedCm7Checksum = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.installedCm4Checksum = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.targetCm7Checksum = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.targetCm4Checksum = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.firmwareUpToDate = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JointInfo {
    return {
      jointNumber: isSet(object.jointNumber) ? globalThis.Number(object.jointNumber) : undefined,
      connectionStatus: isSet(object.connectionStatus) ? jointConnectionStatusFromJSON(object.connectionStatus) : 0,
      firmwareVariant: isSet(object.firmwareVariant) ? globalThis.String(object.firmwareVariant) : undefined,
      firmwareBuildId: isSet(object.firmwareBuildId) ? globalThis.String(object.firmwareBuildId) : undefined,
      jointSerial: isSet(object.jointSerial) ? globalThis.Number(object.jointSerial) : undefined,
      isFake: isSet(object.isFake) ? globalThis.Boolean(object.isFake) : undefined,
      installedCm7Checksum: isSet(object.installedCm7Checksum)
        ? globalThis.Number(object.installedCm7Checksum)
        : undefined,
      installedCm4Checksum: isSet(object.installedCm4Checksum)
        ? globalThis.Number(object.installedCm4Checksum)
        : undefined,
      targetCm7Checksum: isSet(object.targetCm7Checksum) ? globalThis.Number(object.targetCm7Checksum) : undefined,
      targetCm4Checksum: isSet(object.targetCm4Checksum) ? globalThis.Number(object.targetCm4Checksum) : undefined,
      firmwareUpToDate: isSet(object.firmwareUpToDate) ? globalThis.Boolean(object.firmwareUpToDate) : undefined,
    };
  },

  toJSON(message: JointInfo): unknown {
    const obj: any = {};
    if (message.jointNumber !== undefined) {
      obj.jointNumber = Math.round(message.jointNumber);
    }
    if (message.connectionStatus !== 0) {
      obj.connectionStatus = jointConnectionStatusToJSON(message.connectionStatus);
    }
    if (message.firmwareVariant !== undefined) {
      obj.firmwareVariant = message.firmwareVariant;
    }
    if (message.firmwareBuildId !== undefined) {
      obj.firmwareBuildId = message.firmwareBuildId;
    }
    if (message.jointSerial !== undefined) {
      obj.jointSerial = Math.round(message.jointSerial);
    }
    if (message.isFake !== undefined) {
      obj.isFake = message.isFake;
    }
    if (message.installedCm7Checksum !== undefined) {
      obj.installedCm7Checksum = Math.round(message.installedCm7Checksum);
    }
    if (message.installedCm4Checksum !== undefined) {
      obj.installedCm4Checksum = Math.round(message.installedCm4Checksum);
    }
    if (message.targetCm7Checksum !== undefined) {
      obj.targetCm7Checksum = Math.round(message.targetCm7Checksum);
    }
    if (message.targetCm4Checksum !== undefined) {
      obj.targetCm4Checksum = Math.round(message.targetCm4Checksum);
    }
    if (message.firmwareUpToDate !== undefined) {
      obj.firmwareUpToDate = message.firmwareUpToDate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JointInfo>, I>>(base?: I): JointInfo {
    return JointInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JointInfo>, I>>(object: I): JointInfo {
    const message = createBaseJointInfo();
    message.jointNumber = object.jointNumber ?? undefined;
    message.connectionStatus = object.connectionStatus ?? 0;
    message.firmwareVariant = object.firmwareVariant ?? undefined;
    message.firmwareBuildId = object.firmwareBuildId ?? undefined;
    message.jointSerial = object.jointSerial ?? undefined;
    message.isFake = object.isFake ?? undefined;
    message.installedCm7Checksum = object.installedCm7Checksum ?? undefined;
    message.installedCm4Checksum = object.installedCm4Checksum ?? undefined;
    message.targetCm7Checksum = object.targetCm7Checksum ?? undefined;
    message.targetCm4Checksum = object.targetCm4Checksum ?? undefined;
    message.firmwareUpToDate = object.firmwareUpToDate ?? undefined;
    return message;
  },
};

function createBaseGetHardwareConfigResult(): GetHardwareConfigResult {
  return { config: undefined, cbConfig: undefined, errors: [] };
}

export const GetHardwareConfigResult: MessageFns<GetHardwareConfigResult> = {
  encode(message: GetHardwareConfigResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      ArmHardwareConfig.encode(message.config, writer.uint32(10).fork()).join();
    }
    if (message.cbConfig !== undefined) {
      ControlBoxHardwareConfig.encode(message.cbConfig, writer.uint32(18).fork()).join();
    }
    for (const v of message.errors) {
      Error.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetHardwareConfigResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetHardwareConfigResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = ArmHardwareConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cbConfig = ControlBoxHardwareConfig.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.errors.push(Error.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetHardwareConfigResult {
    return {
      config: isSet(object.config) ? ArmHardwareConfig.fromJSON(object.config) : undefined,
      cbConfig: isSet(object.cbConfig) ? ControlBoxHardwareConfig.fromJSON(object.cbConfig) : undefined,
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => Error.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetHardwareConfigResult): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = ArmHardwareConfig.toJSON(message.config);
    }
    if (message.cbConfig !== undefined) {
      obj.cbConfig = ControlBoxHardwareConfig.toJSON(message.cbConfig);
    }
    if (message.errors?.length) {
      obj.errors = message.errors.map((e) => Error.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetHardwareConfigResult>, I>>(base?: I): GetHardwareConfigResult {
    return GetHardwareConfigResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetHardwareConfigResult>, I>>(object: I): GetHardwareConfigResult {
    const message = createBaseGetHardwareConfigResult();
    message.config = (object.config !== undefined && object.config !== null)
      ? ArmHardwareConfig.fromPartial(object.config)
      : undefined;
    message.cbConfig = (object.cbConfig !== undefined && object.cbConfig !== null)
      ? ControlBoxHardwareConfig.fromPartial(object.cbConfig)
      : undefined;
    message.errors = object.errors?.map((e) => Error.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSetImuReportingConfig(): SetImuReportingConfig {
  return { reportInstantaneousData: false };
}

export const SetImuReportingConfig: MessageFns<SetImuReportingConfig> = {
  encode(message: SetImuReportingConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reportInstantaneousData !== false) {
      writer.uint32(8).bool(message.reportInstantaneousData);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetImuReportingConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetImuReportingConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.reportInstantaneousData = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetImuReportingConfig {
    return {
      reportInstantaneousData: isSet(object.reportInstantaneousData)
        ? globalThis.Boolean(object.reportInstantaneousData)
        : false,
    };
  },

  toJSON(message: SetImuReportingConfig): unknown {
    const obj: any = {};
    if (message.reportInstantaneousData !== false) {
      obj.reportInstantaneousData = message.reportInstantaneousData;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetImuReportingConfig>, I>>(base?: I): SetImuReportingConfig {
    return SetImuReportingConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetImuReportingConfig>, I>>(object: I): SetImuReportingConfig {
    const message = createBaseSetImuReportingConfig();
    message.reportInstantaneousData = object.reportInstantaneousData ?? false;
    return message;
  },
};

function createBaseGetFirmwareInfoResult(): GetFirmwareInfoResult {
  return { joints: [] };
}

export const GetFirmwareInfoResult: MessageFns<GetFirmwareInfoResult> = {
  encode(message: GetFirmwareInfoResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.joints) {
      JointInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFirmwareInfoResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFirmwareInfoResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.joints.push(JointInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFirmwareInfoResult {
    return {
      joints: globalThis.Array.isArray(object?.joints) ? object.joints.map((e: any) => JointInfo.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetFirmwareInfoResult): unknown {
    const obj: any = {};
    if (message.joints?.length) {
      obj.joints = message.joints.map((e) => JointInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFirmwareInfoResult>, I>>(base?: I): GetFirmwareInfoResult {
    return GetFirmwareInfoResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFirmwareInfoResult>, I>>(object: I): GetFirmwareInfoResult {
    const message = createBaseGetFirmwareInfoResult();
    message.joints = object.joints?.map((e) => JointInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSetDesireModeRequest(): SetDesireModeRequest {
  return { mode: 0 };
}

export const SetDesireModeRequest: MessageFns<SetDesireModeRequest> = {
  encode(message: SetDesireModeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mode !== 0) {
      writer.uint32(8).int32(message.mode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetDesireModeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetDesireModeRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetDesireModeRequest {
    return { mode: isSet(object.mode) ? desireModeFromJSON(object.mode) : 0 };
  },

  toJSON(message: SetDesireModeRequest): unknown {
    const obj: any = {};
    if (message.mode !== 0) {
      obj.mode = desireModeToJSON(message.mode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetDesireModeRequest>, I>>(base?: I): SetDesireModeRequest {
    return SetDesireModeRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetDesireModeRequest>, I>>(object: I): SetDesireModeRequest {
    const message = createBaseSetDesireModeRequest();
    message.mode = object.mode ?? 0;
    return message;
  },
};

function createBaseSetDesireModeResult(): SetDesireModeResult {
  return { success: false, currentMode: 0 };
}

export const SetDesireModeResult: MessageFns<SetDesireModeResult> = {
  encode(message: SetDesireModeResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    if (message.currentMode !== 0) {
      writer.uint32(16).int32(message.currentMode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetDesireModeResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetDesireModeResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.currentMode = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetDesireModeResult {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      currentMode: isSet(object.currentMode) ? desireModeFromJSON(object.currentMode) : 0,
    };
  },

  toJSON(message: SetDesireModeResult): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.currentMode !== 0) {
      obj.currentMode = desireModeToJSON(message.currentMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetDesireModeResult>, I>>(base?: I): SetDesireModeResult {
    return SetDesireModeResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetDesireModeResult>, I>>(object: I): SetDesireModeResult {
    const message = createBaseSetDesireModeResult();
    message.success = object.success ?? false;
    message.currentMode = object.currentMode ?? 0;
    return message;
  },
};

function createBaseGetDesireModeResult(): GetDesireModeResult {
  return { currentMode: 0 };
}

export const GetDesireModeResult: MessageFns<GetDesireModeResult> = {
  encode(message: GetDesireModeResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.currentMode !== 0) {
      writer.uint32(8).int32(message.currentMode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDesireModeResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDesireModeResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.currentMode = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDesireModeResult {
    return { currentMode: isSet(object.currentMode) ? desireModeFromJSON(object.currentMode) : 0 };
  },

  toJSON(message: GetDesireModeResult): unknown {
    const obj: any = {};
    if (message.currentMode !== 0) {
      obj.currentMode = desireModeToJSON(message.currentMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDesireModeResult>, I>>(base?: I): GetDesireModeResult {
    return GetDesireModeResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDesireModeResult>, I>>(object: I): GetDesireModeResult {
    const message = createBaseGetDesireModeResult();
    message.currentMode = object.currentMode ?? 0;
    return message;
  },
};

function createBaseControlSource(): ControlSource {
  return { value: "", peerId: undefined, clientId: undefined };
}

export const ControlSource: MessageFns<ControlSource> = {
  encode(message: ControlSource, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== "") {
      writer.uint32(10).string(message.value);
    }
    if (message.peerId !== undefined) {
      writer.uint32(18).string(message.peerId);
    }
    if (message.clientId !== undefined) {
      writer.uint32(26).string(message.clientId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ControlSource {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseControlSource();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.value = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.peerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.clientId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ControlSource {
    return {
      value: isSet(object.value) ? globalThis.String(object.value) : "",
      peerId: isSet(object.peerId) ? globalThis.String(object.peerId) : undefined,
      clientId: isSet(object.clientId) ? globalThis.String(object.clientId) : undefined,
    };
  },

  toJSON(message: ControlSource): unknown {
    const obj: any = {};
    if (message.value !== "") {
      obj.value = message.value;
    }
    if (message.peerId !== undefined) {
      obj.peerId = message.peerId;
    }
    if (message.clientId !== undefined) {
      obj.clientId = message.clientId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ControlSource>, I>>(base?: I): ControlSource {
    return ControlSource.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ControlSource>, I>>(object: I): ControlSource {
    const message = createBaseControlSource();
    message.value = object.value ?? "";
    message.peerId = object.peerId ?? undefined;
    message.clientId = object.clientId ?? undefined;
    return message;
  },
};

function createBaseError(): Error {
  return { message: "" };
}

export const Error: MessageFns<Error> = {
  encode(message: Error, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Error {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseError();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Error {
    return { message: isSet(object.message) ? globalThis.String(object.message) : "" };
  },

  toJSON(message: Error): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Error>, I>>(base?: I): Error {
    return Error.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Error>, I>>(object: I): Error {
    const message = createBaseError();
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseSetControlSourceResult(): SetControlSourceResult {
  return { newSource: undefined, error: undefined };
}

export const SetControlSourceResult: MessageFns<SetControlSourceResult> = {
  encode(message: SetControlSourceResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.newSource !== undefined) {
      ControlSource.encode(message.newSource, writer.uint32(10).fork()).join();
    }
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetControlSourceResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetControlSourceResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.newSource = ControlSource.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.error = Error.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetControlSourceResult {
    return {
      newSource: isSet(object.newSource) ? ControlSource.fromJSON(object.newSource) : undefined,
      error: isSet(object.error) ? Error.fromJSON(object.error) : undefined,
    };
  },

  toJSON(message: SetControlSourceResult): unknown {
    const obj: any = {};
    if (message.newSource !== undefined) {
      obj.newSource = ControlSource.toJSON(message.newSource);
    }
    if (message.error !== undefined) {
      obj.error = Error.toJSON(message.error);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetControlSourceResult>, I>>(base?: I): SetControlSourceResult {
    return SetControlSourceResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetControlSourceResult>, I>>(object: I): SetControlSourceResult {
    const message = createBaseSetControlSourceResult();
    message.newSource = (object.newSource !== undefined && object.newSource !== null)
      ? ControlSource.fromPartial(object.newSource)
      : undefined;
    message.error = (object.error !== undefined && object.error !== null) ? Error.fromPartial(object.error) : undefined;
    return message;
  },
};

/** @language: cpp */
export interface ArmControlBotService {
  GetPose(request: Empty): Promise<Pose>;
  GetControlSource(request: Empty): Promise<ControlSource>;
  SetControlSource(request: ControlSource): Promise<SetControlSourceResult>;
  ReleaseControlFromSource(request: ControlSource): Promise<SetControlSourceResult>;
  GetURDF(request: Empty): Promise<URDFResponse>;
  GetHardwareConfig(request: Empty): Promise<GetHardwareConfigResult>;
  SetImuReporting(request: SetImuReportingConfig): Promise<Empty>;
  GetFirmwareInfo(request: Empty): Promise<GetFirmwareInfoResult>;
  SetDesireMode(request: SetDesireModeRequest): Promise<SetDesireModeResult>;
  GetDesireMode(request: Empty): Promise<GetDesireModeResult>;
}

export const ArmControlBotServiceServiceName = "armcontrolbot.ArmControlBotService";
export class ArmControlBotServiceClientImpl implements ArmControlBotService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || ArmControlBotServiceServiceName;
    this.rpc = rpc;
    this.GetPose = this.GetPose.bind(this);
    this.GetControlSource = this.GetControlSource.bind(this);
    this.SetControlSource = this.SetControlSource.bind(this);
    this.ReleaseControlFromSource = this.ReleaseControlFromSource.bind(this);
    this.GetURDF = this.GetURDF.bind(this);
    this.GetHardwareConfig = this.GetHardwareConfig.bind(this);
    this.SetImuReporting = this.SetImuReporting.bind(this);
    this.GetFirmwareInfo = this.GetFirmwareInfo.bind(this);
    this.SetDesireMode = this.SetDesireMode.bind(this);
    this.GetDesireMode = this.GetDesireMode.bind(this);
  }
  GetPose(request: Empty): Promise<Pose> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetPose", data);
    return promise.then((data) => Pose.decode(new BinaryReader(data)));
  }

  GetControlSource(request: Empty): Promise<ControlSource> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetControlSource", data);
    return promise.then((data) => ControlSource.decode(new BinaryReader(data)));
  }

  SetControlSource(request: ControlSource): Promise<SetControlSourceResult> {
    const data = ControlSource.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetControlSource", data);
    return promise.then((data) => SetControlSourceResult.decode(new BinaryReader(data)));
  }

  ReleaseControlFromSource(request: ControlSource): Promise<SetControlSourceResult> {
    const data = ControlSource.encode(request).finish();
    const promise = this.rpc.request(this.service, "ReleaseControlFromSource", data);
    return promise.then((data) => SetControlSourceResult.decode(new BinaryReader(data)));
  }

  GetURDF(request: Empty): Promise<URDFResponse> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetURDF", data);
    return promise.then((data) => URDFResponse.decode(new BinaryReader(data)));
  }

  GetHardwareConfig(request: Empty): Promise<GetHardwareConfigResult> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetHardwareConfig", data);
    return promise.then((data) => GetHardwareConfigResult.decode(new BinaryReader(data)));
  }

  SetImuReporting(request: SetImuReportingConfig): Promise<Empty> {
    const data = SetImuReportingConfig.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetImuReporting", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  GetFirmwareInfo(request: Empty): Promise<GetFirmwareInfoResult> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetFirmwareInfo", data);
    return promise.then((data) => GetFirmwareInfoResult.decode(new BinaryReader(data)));
  }

  SetDesireMode(request: SetDesireModeRequest): Promise<SetDesireModeResult> {
    const data = SetDesireModeRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetDesireMode", data);
    return promise.then((data) => SetDesireModeResult.decode(new BinaryReader(data)));
  }

  GetDesireMode(request: Empty): Promise<GetDesireModeResult> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetDesireMode", data);
    return promise.then((data) => GetDesireModeResult.decode(new BinaryReader(data)));
  }
}

/**
 * @language: typescript, python, cpp, go
 *
 * Sinks marked with @relay automatically re-publish received messages on a
 * PUB/SUB topic named sink/<SinkName>. This allows other services to subscribe
 * to the data flowing into the sink without modifying the sender or receiver.
 * The codegen generates subscribeToSink<Name>() on connectors for relay sinks.
 */
export interface ArmControlBotSinks {
  /** @relay */
  WritePose(request: Pose): Promise<Empty>;
  /** @relay */
  WriteJointTrajectory(request: JointTrajectory): Promise<Empty>;
  ModbusSend(request: ModbusCommand): Promise<Empty>;
  CanSend(request: CanCommand): Promise<Empty>;
  /** @relay */
  WriteEffortCompliance(request: JointTrajectory): Promise<Empty>;
  /**
   * Forces a re-check of Global Accuracy calibration flash data on all 6
   * joints without restarting arm-control-bot. Always all 6 joints; no
   * per-joint variant.
   */
  RecalibrateGlobalAccuracy(request: Empty): Promise<Empty>;
}

export const ArmControlBotSinksServiceName = "armcontrolbot.ArmControlBotSinks";
export class ArmControlBotSinksClientImpl implements ArmControlBotSinks {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || ArmControlBotSinksServiceName;
    this.rpc = rpc;
    this.WritePose = this.WritePose.bind(this);
    this.WriteJointTrajectory = this.WriteJointTrajectory.bind(this);
    this.ModbusSend = this.ModbusSend.bind(this);
    this.CanSend = this.CanSend.bind(this);
    this.WriteEffortCompliance = this.WriteEffortCompliance.bind(this);
    this.RecalibrateGlobalAccuracy = this.RecalibrateGlobalAccuracy.bind(this);
  }
  WritePose(request: Pose): Promise<Empty> {
    const data = Pose.encode(request).finish();
    const promise = this.rpc.request(this.service, "WritePose", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  WriteJointTrajectory(request: JointTrajectory): Promise<Empty> {
    const data = JointTrajectory.encode(request).finish();
    const promise = this.rpc.request(this.service, "WriteJointTrajectory", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  ModbusSend(request: ModbusCommand): Promise<Empty> {
    const data = ModbusCommand.encode(request).finish();
    const promise = this.rpc.request(this.service, "ModbusSend", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  CanSend(request: CanCommand): Promise<Empty> {
    const data = CanCommand.encode(request).finish();
    const promise = this.rpc.request(this.service, "CanSend", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  WriteEffortCompliance(request: JointTrajectory): Promise<Empty> {
    const data = JointTrajectory.encode(request).finish();
    const promise = this.rpc.request(this.service, "WriteEffortCompliance", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  RecalibrateGlobalAccuracy(request: Empty): Promise<Empty> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "RecalibrateGlobalAccuracy", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }
}

/** @language: cpp */
export interface ArmControlBotTopics {
  Pose(request: Pose): Promise<Empty>;
  JointState(request: JointState): Promise<Empty>;
  Wrench(request: Wrench): Promise<Empty>;
  HardwareConfig(request: GetHardwareConfigResult): Promise<Empty>;
  ModbusReceive(request: ModbusCommand): Promise<Empty>;
  DesireModeChanged(request: GetDesireModeResult): Promise<Empty>;
  CollisionStatus(request: CollisionStatus): Promise<Empty>;
}

export const ArmControlBotTopicsServiceName = "armcontrolbot.ArmControlBotTopics";
export class ArmControlBotTopicsClientImpl implements ArmControlBotTopics {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || ArmControlBotTopicsServiceName;
    this.rpc = rpc;
    this.Pose = this.Pose.bind(this);
    this.JointState = this.JointState.bind(this);
    this.Wrench = this.Wrench.bind(this);
    this.HardwareConfig = this.HardwareConfig.bind(this);
    this.ModbusReceive = this.ModbusReceive.bind(this);
    this.DesireModeChanged = this.DesireModeChanged.bind(this);
    this.CollisionStatus = this.CollisionStatus.bind(this);
  }
  Pose(request: Pose): Promise<Empty> {
    const data = Pose.encode(request).finish();
    const promise = this.rpc.request(this.service, "Pose", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  JointState(request: JointState): Promise<Empty> {
    const data = JointState.encode(request).finish();
    const promise = this.rpc.request(this.service, "JointState", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  Wrench(request: Wrench): Promise<Empty> {
    const data = Wrench.encode(request).finish();
    const promise = this.rpc.request(this.service, "Wrench", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  HardwareConfig(request: GetHardwareConfigResult): Promise<Empty> {
    const data = GetHardwareConfigResult.encode(request).finish();
    const promise = this.rpc.request(this.service, "HardwareConfig", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  ModbusReceive(request: ModbusCommand): Promise<Empty> {
    const data = ModbusCommand.encode(request).finish();
    const promise = this.rpc.request(this.service, "ModbusReceive", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  DesireModeChanged(request: GetDesireModeResult): Promise<Empty> {
    const data = GetDesireModeResult.encode(request).finish();
    const promise = this.rpc.request(this.service, "DesireModeChanged", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }

  CollisionStatus(request: CollisionStatus): Promise<Empty> {
    const data = CollisionStatus.encode(request).finish();
    const promise = this.rpc.request(this.service, "CollisionStatus", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type ProtoMetaMessageOptions = {
  options?: { [key: string]: any };
  fields?: { [key: string]: { [key: string]: any } };
  oneof?: { [key: string]: { [key: string]: any } };
  nested?: { [key: string]: ProtoMetaMessageOptions };
};

export interface ProtoMetadata {
  fileDescriptor: FileDescriptorProto1;
  references: { [key: string]: any };
  dependencies?: ProtoMetadata[];
  options?: {
    options?: { [key: string]: any };
    services?: {
      [key: string]: { options?: { [key: string]: any }; methods?: { [key: string]: { [key: string]: any } } };
    };
    messages?: { [key: string]: ProtoMetaMessageOptions };
    enums?: { [key: string]: { options?: { [key: string]: any }; values?: { [key: string]: { [key: string]: any } } } };
  };
}

export const protoMetadata: ProtoMetadata = {
  fileDescriptor: {
    "name": "messenger/arm_control_bot_service.proto",
    "package": "armcontrolbot",
    "dependency": [
      "messenger/geometry.proto",
      "messenger/grippers.proto",
      "messenger/joints.proto",
      "google/protobuf/empty.proto",
    ],
    "publicDependency": [],
    "weakDependency": [],
    "messageType": [{
      "name": "URDFResponse",
      "field": [{
        "name": "urdf_xml",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "urdfXml",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ArmHardwareConfig",
      "field": [{
        "name": "hardware_variant",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "hardwareVariant",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "arm_serial_number",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "armSerialNumber",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "arm_revision",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "armRevision",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "joint_serials",
        "number": 4,
        "label": 3,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "jointSerials",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ml_windup_calibrated",
        "number": 5,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "mlWindupCalibrated",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_arm_serial_number", "options": undefined }, {
        "name": "_arm_revision",
        "options": undefined,
      }, { "name": "_ml_windup_calibrated", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ControlBoxHardwareConfig",
      "field": [{
        "name": "voltage",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "voltage",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "JointInfo",
      "field": [{
        "name": "joint_number",
        "number": 1,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "jointNumber",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "connection_status",
        "number": 2,
        "label": 1,
        "type": 14,
        "typeName": ".armcontrolbot.JointConnectionStatus",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "connectionStatus",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "firmware_variant",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "firmwareVariant",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "firmware_build_id",
        "number": 4,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "firmwareBuildId",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "joint_serial",
        "number": 5,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 3,
        "jsonName": "jointSerial",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "is_fake",
        "number": 6,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 4,
        "jsonName": "isFake",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "installed_cm7_checksum",
        "number": 7,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 5,
        "jsonName": "installedCm7Checksum",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "installed_cm4_checksum",
        "number": 8,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 6,
        "jsonName": "installedCm4Checksum",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "target_cm7_checksum",
        "number": 9,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 7,
        "jsonName": "targetCm7Checksum",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "target_cm4_checksum",
        "number": 10,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 8,
        "jsonName": "targetCm4Checksum",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "firmware_up_to_date",
        "number": 11,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 9,
        "jsonName": "firmwareUpToDate",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [
        { "name": "_joint_number", "options": undefined },
        { "name": "_firmware_variant", "options": undefined },
        { "name": "_firmware_build_id", "options": undefined },
        { "name": "_joint_serial", "options": undefined },
        { "name": "_is_fake", "options": undefined },
        { "name": "_installed_cm7_checksum", "options": undefined },
        { "name": "_installed_cm4_checksum", "options": undefined },
        { "name": "_target_cm7_checksum", "options": undefined },
        { "name": "_target_cm4_checksum", "options": undefined },
        { "name": "_firmware_up_to_date", "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GetHardwareConfigResult",
      "field": [{
        "name": "config",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".armcontrolbot.ArmHardwareConfig",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "config",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "cb_config",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".armcontrolbot.ControlBoxHardwareConfig",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "cbConfig",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "errors",
        "number": 3,
        "label": 3,
        "type": 11,
        "typeName": ".armcontrolbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "errors",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SetImuReportingConfig",
      "field": [{
        "name": "report_instantaneous_data",
        "number": 1,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "reportInstantaneousData",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GetFirmwareInfoResult",
      "field": [{
        "name": "joints",
        "number": 1,
        "label": 3,
        "type": 11,
        "typeName": ".armcontrolbot.JointInfo",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "joints",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SetDesireModeRequest",
      "field": [{
        "name": "mode",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".armcontrolbot.DesireMode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "mode",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SetDesireModeResult",
      "field": [{
        "name": "success",
        "number": 1,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "success",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "current_mode",
        "number": 2,
        "label": 1,
        "type": 14,
        "typeName": ".armcontrolbot.DesireMode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "currentMode",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GetDesireModeResult",
      "field": [{
        "name": "current_mode",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".armcontrolbot.DesireMode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "currentMode",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ControlSource",
      "field": [{
        "name": "value",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "value",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "peer_id",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "peerId",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "client_id",
        "number": 3,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "clientId",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_peer_id", "options": undefined }, { "name": "_client_id", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Error",
      "field": [{
        "name": "message",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "message",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SetControlSourceResult",
      "field": [{
        "name": "new_source",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".armcontrolbot.ControlSource",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "newSource",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".armcontrolbot.Error",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "error",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "result", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "enumType": [{
      "name": "JointConnectionStatus",
      "value": [{ "name": "JOINT_DISCONNECTED", "number": 0, "options": undefined }, {
        "name": "JOINT_CONNECTED",
        "number": 1,
        "options": undefined,
      }, { "name": "JOINT_READY", "number": 2, "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DesireMode",
      "value": [{ "name": "DESIRE_MODE_ASSEMBLY", "number": 0, "options": undefined }, {
        "name": "DESIRE_MODE_LIVE",
        "number": 1,
        "options": undefined,
      }, { "name": "DESIRE_MODE_IDLE", "number": 2, "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "service": [{
      "name": "ArmControlBotService",
      "method": [{
        "name": "GetPose",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".geometry.Pose",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "GetControlSource",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".armcontrolbot.ControlSource",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "SetControlSource",
        "inputType": ".armcontrolbot.ControlSource",
        "outputType": ".armcontrolbot.SetControlSourceResult",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ReleaseControlFromSource",
        "inputType": ".armcontrolbot.ControlSource",
        "outputType": ".armcontrolbot.SetControlSourceResult",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "GetURDF",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".armcontrolbot.URDFResponse",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "GetHardwareConfig",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".armcontrolbot.GetHardwareConfigResult",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "SetImuReporting",
        "inputType": ".armcontrolbot.SetImuReportingConfig",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "GetFirmwareInfo",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".armcontrolbot.GetFirmwareInfoResult",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "SetDesireMode",
        "inputType": ".armcontrolbot.SetDesireModeRequest",
        "outputType": ".armcontrolbot.SetDesireModeResult",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "GetDesireMode",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".armcontrolbot.GetDesireModeResult",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }, {
      "name": "ArmControlBotSinks",
      "method": [{
        "name": "WritePose",
        "inputType": ".geometry.Pose",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "WriteJointTrajectory",
        "inputType": ".joints.JointTrajectory",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ModbusSend",
        "inputType": ".grippers.ModbusCommand",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "CanSend",
        "inputType": ".grippers.CanCommand",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "WriteEffortCompliance",
        "inputType": ".joints.JointTrajectory",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "RecalibrateGlobalAccuracy",
        "inputType": ".google.protobuf.Empty",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }, {
      "name": "ArmControlBotTopics",
      "method": [{
        "name": "Pose",
        "inputType": ".geometry.Pose",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "JointState",
        "inputType": ".joints.JointState",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "Wrench",
        "inputType": ".geometry.Wrench",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "HardwareConfig",
        "inputType": ".armcontrolbot.GetHardwareConfigResult",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ModbusReceive",
        "inputType": ".grippers.ModbusCommand",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "DesireModeChanged",
        "inputType": ".armcontrolbot.GetDesireModeResult",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "CollisionStatus",
        "inputType": ".joints.CollisionStatus",
        "outputType": ".google.protobuf.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }],
    "extension": [],
    "options": {
      "javaPackage": "",
      "javaOuterClassname": "",
      "javaMultipleFiles": false,
      "javaGenerateEqualsAndHash": false,
      "javaStringCheckUtf8": false,
      "optimizeFor": 1,
      "goPackage": "sb.app/messenger/proto/armcontrolbot",
      "ccGenericServices": false,
      "javaGenericServices": false,
      "pyGenericServices": false,
      "phpGenericServices": false,
      "deprecated": false,
      "ccEnableArenas": true,
      "objcClassPrefix": "",
      "csharpNamespace": "",
      "swiftPrefix": "",
      "phpClassPrefix": "",
      "phpNamespace": "",
      "phpMetadataNamespace": "",
      "rubyPackage": "",
      "uninterpretedOption": [],
    },
    "sourceCodeInfo": {
      "location": [{
        "path": [4, 0],
        "span": [10, 0, 12, 1],
        "leadingComments": " Response message for URDF data\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 1],
        "span": [15, 0, 24, 1],
        "leadingComments": " Summary of hardware configuration across all joints\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 1, 2, 4],
        "span": [23, 2, 41],
        "leadingComments":
          " True once every ML-capable joint reports calibrated, false if any\n definitively reports otherwise. Unset when only silence separates us from\n an answer, or the arm has no ML-capable joints.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 0],
        "span": [31, 0, 35, 1],
        "leadingComments": " Joint connection status enum\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3],
        "span": [38, 0, 62, 1],
        "leadingComments": " Information about a single joint\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3, 2, 2],
        "span": [41, 2, 39],
        "leadingComments": "",
        "trailingComments": " RO1, RO2, THOR, SPARK, etc.\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3, 2, 5],
        "span": [44, 2, 28],
        "leadingComments": "",
        "trailingComments": " True if joint is marked as JointFakeConfig in arm-control-bot.json\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3, 2, 6],
        "span": [47, 2, 44],
        "leadingComments":
          " Installed checksums (queried from CAN by ACB). Absent when the\n joint is disconnected or fake.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3, 2, 8],
        "span": [53, 2, 41],
        "leadingComments":
          " Target checksums (from firmware-bot-cpp --list --json, matched to\n this joint's (firmwareType, variant)). Absent when firmware-bot-cpp\n is unreachable or this joint's (firmwareType, variant) is not in\n the target set.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 3, 2, 10],
        "span": [61, 2, 41],
        "leadingComments":
          " ACB-computed comparison of installed vs target:\n   - true  when installed == target (all CM7/CM4 fields match), OR\n           when the joint is fake (nothing to flash, treated as up to date).\n   - false when installed != target.\n   - absent when ACB can't determine (installed or target missing for a\n           real joint). UI should fall back to buildId comparison.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 4],
        "span": [65, 0, 69, 1],
        "leadingComments": " Result wrapper for GetHardwareConfig\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 5],
        "span": [75, 0, 77, 1],
        "leadingComments":
          " Message for end-effector IMU reporting configuration. Used by kalibrate-bot\n to enable the ~250 Hz instantaneous accelerometer stream during MPA\n smoothness runs, then disable it when the run ends. Default is off so we\n don't waste CAN bandwidth outside of MPA.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 6],
        "span": [80, 0, 82, 1],
        "leadingComments": " Result for GetFirmwareInfo - firmware state across all known boards\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1],
        "span": [85, 0, 89, 1],
        "leadingComments": " Desire mode for hybrid assembly operation\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 0],
        "span": [86, 2, 27],
        "leadingComments": "",
        "trailingComments": " Default: robby-server sends assembly desires\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 1],
        "span": [87, 2, 23],
        "leadingComments": "",
        "trailingComments": " ACB sends CombinedDesires\n",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 1, 2, 2],
        "span": [88, 2, 23],
        "leadingComments": "",
        "trailingComments": " Nobody sends desires, arm braked\n",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 0],
        "span": [105, 0, 116, 1],
        "leadingComments": " @language: cpp\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 1],
        "span": [124, 0, 137, 1],
        "leadingComments":
          " @language: typescript, python, cpp, go\n\n Sinks marked with @relay automatically re-publish received messages on a\n PUB/SUB topic named sink/<SinkName>. This allows other services to subscribe\n to the data flowing into the sink without modifying the sender or receiver.\n The codegen generates subscribeToSink<Name>() on connectors for relay sinks.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 1, 2, 0],
        "span": [126, 2, 63],
        "leadingComments": " @relay\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 1, 2, 1],
        "span": [128, 2, 83],
        "leadingComments": " @relay\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 1, 2, 4],
        "span": [132, 2, 84],
        "leadingComments": " @relay\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 1, 2, 5],
        "span": [136, 2, 87],
        "leadingComments":
          " Forces a re-check of Global Accuracy calibration flash data on all 6\n joints without restarting arm-control-bot. Always all 6 joints; no\n per-joint variant.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 2],
        "span": [140, 0, 148, 1],
        "leadingComments": " @language: cpp\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 10, 2, 2],
        "span": [154, 2, 32],
        "leadingComments": " TODO: remove optional when everyone sends in client_id\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }],
    },
    "syntax": "proto3",
  },
  references: {
    ".armcontrolbot.JointConnectionStatus": JointConnectionStatus,
    ".armcontrolbot.DesireMode": DesireMode,
    ".armcontrolbot.URDFResponse": URDFResponse,
    ".armcontrolbot.ArmHardwareConfig": ArmHardwareConfig,
    ".armcontrolbot.ControlBoxHardwareConfig": ControlBoxHardwareConfig,
    ".armcontrolbot.JointInfo": JointInfo,
    ".armcontrolbot.GetHardwareConfigResult": GetHardwareConfigResult,
    ".armcontrolbot.SetImuReportingConfig": SetImuReportingConfig,
    ".armcontrolbot.GetFirmwareInfoResult": GetFirmwareInfoResult,
    ".armcontrolbot.SetDesireModeRequest": SetDesireModeRequest,
    ".armcontrolbot.SetDesireModeResult": SetDesireModeResult,
    ".armcontrolbot.GetDesireModeResult": GetDesireModeResult,
    ".armcontrolbot.ControlSource": ControlSource,
    ".armcontrolbot.Error": Error,
    ".armcontrolbot.SetControlSourceResult": SetControlSourceResult,
    ".armcontrolbot.ArmControlBotService": ArmControlBotServiceClientImpl,
    ".armcontrolbot.ArmControlBotSinks": ArmControlBotSinksClientImpl,
    ".armcontrolbot.ArmControlBotTopics": ArmControlBotTopicsClientImpl,
  },
  dependencies: [protoMetadata1, protoMetadata2, protoMetadata3, protoMetadata4],
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
